import { emitCustomEvent } from 'react-custom-events'

const success = (response) => {
  if (response?.data?.errors?.length > 0) {
    const error = response.data.errors[0];


    if (error.code === 'P002') {
      emitCustomEvent('log_out')
    }
  }
  return response;
};

const error = (error) => {
  if (error && error.response && 401 === error.response.status) {
    if (typeof localStorage != 'object') return;
    localStorage.removeItem("authStore");

    if (typeof window != 'object') return;

    // window.location = '/log_in';
  } else {
    return Promise.reject(error);
  }
}

export default [success, error];
